const {httpConfig} = require('./config');
const {APP_CONST} = require('./constants');
const Env = process.env.REACT_APP_APP_CONFIG;
const ENV_ENCRYPTION_KEY = "7328f9dd0d48b078e17aea8736cadb4b"
export {
    httpConfig,
    APP_CONST,
    Env,
    ENV_ENCRYPTION_KEY
}